"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./../styles/Elecinstallation.css";

import Header from './Header';
import Footer from './Footer';
import Beams from "./Beams";

import image1 from "../assets/manpower17A.jpeg";
import image2 from "../assets/manpower12A.jpeg";
import image3 from "../assets/manpower13A.jpeg";
import image4 from "../assets/testing14A.jpeg";
import image5 from "../assets/testing15A.jpeg";
import image6 from "../assets/manpower16A.jpeg";
import image7 from "../assets/manpower11A.jpeg";
import image8 from "../assets/manpower18A.jpeg";
import image9 from "../assets/manpower8A.png";

// --- Inner Timeline Component ---
const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(scrollYProgress, [0, 1], [0, timelineHeight]);
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        <h2 className="elec-design-hero-title">Skilled Manpower Services</h2>
        <p className="elec-design-hero-description">
          "Expertise On Demand" – Gain immediate access to certified professionals with hands-on experience, ensuring your projects are executed efficiently, safely, and to the highest industry standards.
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <img
                src={item.image}
                alt={item.title}
                className="elec-design-hero-step-image mn-img1"
                data-aos="fade-left"
              />
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {typeof item.paragraph === "string" ? (
                  <p>{item.paragraph}</p>
                ) : (
                  <>
                    {item.paragraph.text && <p>{item.paragraph.text}</p>}

                    {Array.isArray(item.paragraph.points) &&
                      item.paragraph.points.map((point, idx) =>
                        typeof point === "string" ? (
                          <p key={idx} className="elec-design-hero-step-point">
                            <span className="elec-design-hero-arrow-icon">→</span> {point}
                          </p>
                        ) : (
                          <div key={idx} className="elec-design-hero-step-subpoint">
                            <h4>
                              <span className="elec-design-hero-star-icon">★</span>
                              {point.heading.replace(/^★\s*/, "")}
                            </h4>
                            <p>{point.description}</p>
                          </div>
                        )
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

// --- Main Page Component ---
const Skilledmanpower = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
    {
      title: "Our Offerings",
      image: image7,
      paragraph: {
        text: "",
        points: [
          {
            heading: "★    Expert Manpower Supply: ",
            description: "      •Access to a diverse pool of experienced electricians, technicians, and engineers."
          },
          {
            heading: "★    Tailored Staffing: ",
            description: "      •Customized staffing solutions designed to fit the specific requirements of your project."
          },
          {
            heading: "★   End-to-End Support: ",
            description: "      •From initial recruitment to on-site management, we ensure a smooth integration of our personnel into your team."
          },
          {
            heading: "★    Quality Assurance: ",
            description: "      •Rigorous vetting and training processes to guarantee only the highest caliber professionals are deployed."
          }
        ]
      }
    },
    {
      title: "Why Partner with Us?",
      image: image8,
      paragraph: {
        text: "",
        points: [
          {
            heading: "★    Industry Expertise:",
            description: "      •Over 10 years of proven experience in the electrical sector."
          },
          {
            heading: "★   Dependability:",
            description: "      • Consistently providing high-quality manpower solutions."
          },
          {
            heading: "★    Client-Centric Approach:",
            description: "      •	Dedicated to surpassing client expectations with every engagement."
          },
          {
            heading: "★ Civil Laborers & Masons:",
            description: "• Trained for site work, construction, finishing, and heavy-duty support tasks."
          },
          {
            heading: "★    Extensive Network:",
            description: "      • A vast network of skilled professionals across various specializations."
          },
          {
            heading: "★       Deployment:",
            description: " •   Efficient deployment of skilled manpower to your project site."
          },
        ]
      }
    },
    {
      title: "Our Approach",
      image: image9,
      paragraph: {
        text: "",
        points: [
          {
            heading: "★    Needs Assessment:",
            description: "      •In-depth understanding of your project's requirements and objectives."
          },
          {
            heading: "★   Candidate Selection: ",
            description: "•  Careful selection of the most qualified candidates for your project."
          },
          {
            heading: "★   Ongoing Support:",
            description: "      • Continuous support and oversight throughout the project duration."
          }
        ]
      }
    }
  ];

  return (
    <>
      <Header />
      <div className="elec-installation-page-container">
        <div className="elec-installation-page-header">
          <h1>Manpower</h1>
          <p>
               we pride ourselves on delivering top-tier electrical manpower services tailored to meet the unique needs of your projects. With over a decade of industry expertise, our commitment is to provide reliable, skilled, and efficient electrical professionals to ensure the seamless execution of your operations.
          </p>
        </div>

        <div className="elec-installation-cube-wrapper">
          <div className="elec-installation-cube-gallery">
            <img src={image1} alt="Worker Slide 1" />
            <img src={image2} alt="Worker Slide 2" />
            <img src={image3} alt="Worker Slide 3" />
            <img src={image4} alt="Worker Slide 4" />
            <img src={image5} alt="Worker Slide 5" />
            <img src={image6} alt="Worker Slide 6" />
          </div>
        </div>

        <div className="epc-beam-background">
           <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>
      </div>

      <ElecDesignHeroSection data={timelineData} />
      <Footer />
    </>
  );
};

export default Skilledmanpower;
